module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_BlackMatted.02f59179.jpg";